import { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import { api } from '../api';
import { toast } from 'sonner';

export default function Demo() {
  const { token } = useParams();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current || !token) return;
    done.current = true;

    api.post('/demo/authenticate', { token })
      .then(user => {
        setUser(user);
        toast.success('Bienvenue en mode démo — données anonymisées');
        navigate('/group-classes');
      })
      .catch(err => {
        toast.error(err?.message || 'Lien démo invalide ou expiré');
        navigate('/login');
      });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-[#0288D1] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-slate-500 text-sm">Chargement du mode démo…</p>
      </div>
    </div>
  );
}
